import { FaTimes } from "react-icons/fa";

const VARIANT_STYLES = {
  warning: { bg: "bg-orange-100", border: "border-orange-500", text: "text-orange-700" },
  success: { bg: "bg-green-100", border: "border-green-500", text: "text-green-700" },
  failure: { bg: "bg-red-100", border: "border-red-500", text: "text-red-700" },
};

// Shared bordered-card alert style used for the unassigned-stay warning and
// the accept/decline notification banners, so both read as one visual
// language instead of two different treatments (solid blocks vs bordered
// cards) across the Upcoming Stays and Dashboard pages.
export default function AlertBanner({
  variant = "warning",
  icon,
  onClick,
  onDismiss,
  action,
  className = "",
  children,
}) {
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.warning;

  return (
    <div
      role="alert"
      className={`flex md:flex-row flex-col md:items-center gap-3 ${styles.bg} border-l-4 ${styles.border} ${styles.text} rounded-lg p-4 w-full ${className}`}
    >
      {icon && <span className="flex-shrink-0 mt-0.5">{icon}</span>}
      {onClick ? (
        <button type="button" onClick={onClick} className="flex-1 min-w-0 text-left">
          {children}
        </button>
      ) : (
        <div className="flex-1 min-w-0">{children}</div>
      )}
      {action}
      {onDismiss && (
        <button
          type="button"
          aria-label="Dismiss notification"
          onClick={onDismiss}
          className="flex-shrink-0 opacity-70 hover:opacity-100 transition-opacity"
        >
          <FaTimes />
        </button>
      )}
    </div>
  );
}
